import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faMobileAlt,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import contacts from "../data/contacts.json";
import SEO from "./common/SEO";

const Contacts = () => {
  const { t, i18n } = useTranslation();
  const isEnglish = (i18n.language || "it").startsWith("en");
  const title = isEnglish ? "Contacts" : "Contatti";
  const desc = isEnglish
    ? "Contact the Nuova Orchestra da Camera Ferruccio Busoni of Trieste: artistic direction, phone, email, and social channels."
    : "Contatta la Nuova Orchestra da Camera Ferruccio Busoni di Trieste: direzione artistica, segreteria, telefono, email e canali social.";

  return (
    <>
      <SEO title={title} description={desc} />
      <section className="section subpage-section contacts-section">
        <div className="container subpage-reading-container text-center">
          {/* Cards Grid - perfectly centered */}
          <div className="row justify-content-center g-4">
            {contacts.map((contact, index) => (
              <div key={index} className="col-12 col-md-6">
                <div className="card contact-modern-card border-0 shadow-sm rounded-4 p-4 bg-white text-center h-100 d-flex flex-column justify-content-center align-items-center">
                  {/* Role Title */}
                  <h4 className="text-capitalize contact-title mb-2 fw-bold text-dark">
                    {t(`contacts.${contact.title}`)}
                  </h4>

                  {/* Name */}
                  {contact.name && (
                    <div className="contact-name text-muted fw-semibold mb-3">
                      {contact.name}
                    </div>
                  )}

                  {/* Contact Info Items */}
                  <div className="contact-info-list d-flex flex-column align-items-center gap-2 mt-auto w-100">
                    {contact.telFax && (
                      <div className="contact-info-item d-flex align-items-center justify-content-center">
                        <FontAwesomeIcon icon={faPhone} className="text-warning me-2" />
                        <span className="small text-muted me-1">{t("contacts.tel_fax")}:</span>
                        <a href={`tel:${contact.telFax.replace(/\s+/g, "")}`} className="fw-semibold text-dark text-decoration-none">
                          {contact.telFax}
                        </a>
                      </div>
                    )}

                    {contact.cell && (
                      <div className="contact-info-item d-flex align-items-center justify-content-center">
                        <FontAwesomeIcon icon={faMobileAlt} className="text-warning me-2" />
                        <span className="small text-muted me-1">{t("contacts.cell")}:</span>
                        <a href={`tel:${contact.cell.replace(/\s+/g, "")}`} className="fw-semibold text-dark text-decoration-none">
                          {contact.cell}
                        </a>
                      </div>
                    )}

                    {contact.email && (
                      <div className="contact-info-item d-flex align-items-center justify-content-center mt-1">
                        <a
                          href={`mailto:${contact.email}`}
                          className="contact-email-link"
                        >
                          <FontAwesomeIcon icon={faEnvelope} className="email-icon" />
                          <span>{contact.email}</span>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Contacts;
